import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusLabel',
  standalone: true
})
export class StatusLabelPipe implements PipeTransform {
  private statusMap: Record<string, string> = {
    'PENDING': 'На рассмотрении',
    'APPROVED': 'Одобрено',
    'REJECTED': 'Отклонено',
    'UNDER_CONSIDERATION': 'В обработке',
    'ALLOCATED': 'Квота распределена',
    'QUOTA_REVOKED': 'Квота изъята'
  };

  transform(status: string): string {
    return this.statusMap[status] || status;
  }
}
